import { type BlueprintsState } from './blueprints/types';
import { type ConnectSpaceDialogState } from './connect-space/types';
import { type CreateSpaceDialogState } from './create-space/types';
import { type InlineJoinState } from './inline-join/types';
import { type OnDemandActivationUIState } from './ondemand-activation/types';

export const CONFTREE_PLACEHOLDER = 'CONFTREE_PLACEHOLDER';
export const CONFTREE_CROSS_SELL = 'CONFTREE_CROSS_SELL';
export const CONFTREE_CONFLUENCE_ACTIVATING = 'CONFTREE_CONFLUENCE_ACTIVATING';
export const CONFTREE_CONNECT_SPACE = 'CONFTREE_CONNECT_SPACE';
export const CONFTREE_DISPLAY_PAGETREE = 'CONFTREE_DISPLAY_PAGETREE';
export const CONFTREE_ERROR = 'CONFTREE_ERROR';
export const CONFTREE_NO_ACCESS_TEASER = 'CONFTREE_NO_ACCESS_TEASER';
export const CONFTREE_ACCESS_LOADING = 'CONFTREE_ACCESS_LOADING';
export const CONFTREE_SPACE_NOT_FOUND = 'CONFTREE_SPACE_NOT_FOUND';
export const CONFTREE_PAGE_NOT_FOUND = 'CONFTREE_PAGE_NOT_FOUND';
export const CONFLUENCE_CONNECTION_BROKEN = 'CONFLUENCE_CONNECTION_BROKEN';
export const CONFTREE_CONFLUENCE_ACTIVATING_ONDEMAND = 'CONFTREE_CONFLUENCE_ACTIVATING_ONDEMAND';

export type ConfluenceLicenseStatusList =
	| typeof CONFTREE_CONFLUENCE_ACTIVATING
	| typeof CONFTREE_CONNECT_SPACE
	| typeof CONFTREE_CROSS_SELL
	| typeof CONFTREE_DISPLAY_PAGETREE
	| typeof CONFTREE_ERROR
	| typeof CONFTREE_PLACEHOLDER
	| typeof CONFTREE_NO_ACCESS_TEASER
	| typeof CONFTREE_ACCESS_LOADING
	| typeof CONFTREE_SPACE_NOT_FOUND
	| typeof CONFTREE_PAGE_NOT_FOUND
	| typeof CONFLUENCE_CONNECTION_BROKEN
	| typeof CONFTREE_CONFLUENCE_ACTIVATING_ONDEMAND;

export type UIState = {
	blueprints: BlueprintsState;
	connectSpaceDialog: ConnectSpaceDialogState;
	createSpaceDialog: CreateSpaceDialogState;
	inlineJoin: InlineJoinState;
	onDemandActivation: OnDemandActivationUIState;
};
